export default "__VITE_ASSET__24b62ba0__"